import { Box, Typography } from "@mui/material";
import React, { useEffect } from "react";
import EmbraceLogo from "../Common/EmbraceLogo";
import { useQuery } from "../../utils/hooks";
import { useAppDispatch } from "../../Redux/hooks";
import { resetState } from "../../Redux/actions/resetAction";
import { useTranslation } from "react-i18next";

const CheckMarkIcon = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40 12C47.4261 12 54.5478 14.9502 59.7988 20.2012C65.0498 25.4522 68 32.5739 68 40C68 47.4261 65.0498 54.5478 59.7988 59.7988C54.5478 65.0498 47.4261 68 40 68C32.5739 68 25.4522 65.0498 20.2012 59.7988C14.9502 54.5478 12 47.4261 12 40C12 32.5739 14.9502 25.4522 20.2012 20.2012C25.4522 14.9502 32.5739 12 40 12ZM52.0205 24.0498C49.923 24.0316 47.9023 24.8378 46.3936 26.2949L46.3682 26.3193L36 36.6875L33.6318 34.3193L33.6064 34.2949L33.3184 34.0293C31.8454 32.7399 29.9461 32.0327 27.9795 32.0498C25.882 32.0681 23.8758 32.9093 22.3926 34.3926C20.9093 35.8758 20.0681 37.882 20.0498 39.9795C20.0316 42.077 20.8378 44.0977 22.2949 45.6064L22.3193 45.6318L30.3438 53.6562V53.6572C31.844 55.157 33.8787 55.999 36 55.999C38.1213 55.999 40.156 55.157 41.6562 53.6572V53.6562L57.6807 37.6318L57.7051 37.6064C59.1622 36.0976 59.9684 34.077 59.9502 31.9795C59.9319 29.882 59.0907 27.8758 57.6074 26.3926C56.1242 24.9093 54.118 24.0681 52.0205 24.0498Z"
      fill="#0E9F6E"
      stroke="#0E9F6E"
      strokeWidth="8"
    />
  </svg>
);

const ThankYou = () => {
  const type = useQuery().get("type");
  const dispatch = useAppDispatch();
  const { t } = useTranslation("participant-flow");
  const eligibilityStatus =
    sessionStorage.getItem("screening-eligibility-status") || "";

  useEffect(() => {
    const storedStatus = sessionStorage.getItem("screening-eligibility-status");
    localStorage.clear();
    if (storedStatus) {
      sessionStorage.setItem("screening-eligibility-status", storedStatus);
    }
    dispatch(resetState());
  }, [dispatch]);

  const screeningTitleKey =
    eligibilityStatus === "screened"
      ? "THANK_YOU_SCREENING_ELIGIBLE_TITLE"
      : eligibilityStatus === "excluded"
        ? "THANK_YOU_SCREENING_INELIGIBLE_TITLE"
        : "THANK_YOU_SCREENING_TITLE";
  const screeningBodyKey =
    eligibilityStatus === "screened"
      ? "THANK_YOU_SCREENING_ELIGIBLE_BODY"
      : eligibilityStatus === "excluded"
        ? "THANK_YOU_SCREENING_INELIGIBLE_BODY"
        : "THANK_YOU_SCREENING_BODY";

  return (
    <>
      <Box
        component="header"
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          width: "100%",
          height: "4rem",
          borderBottom: "1px solid hsl(270 20% 90%)",
          backgroundColor: "hsl(0 0% 100% / 0.8)",
          backdropFilter: "blur(4px)",
          WebkitBackdropFilter: "blur(4px)",
          padding: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            height: "100%",
          }}
        >
          <EmbraceLogo sx={{ height: { xs: 40, md: 44 } }} />
        </Box>
      </Box>
      <Box
        sx={{
          height: "calc(100% - 4rem)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <CheckMarkIcon />
        {type === "consent" ? (
          <Typography variant="h2" sx={{ mt: 2, mb: "4px" }}>
            {t("THANK_YOU_CONSENT_TITLE")}
          </Typography>
        ) : (
          <Typography variant="h2" sx={{ mt: 2, mb: "4px" }}>
            {t(screeningTitleKey)}
          </Typography>
        )}
        <Typography variant="body1" fontWeight="regular">
          {type === "consent"
            ? t("THANK_YOU_CONSENT_BODY")
            : t(screeningBodyKey)}
        </Typography>
      </Box>
    </>
  );
};

export default ThankYou;
